module.exports = __webpack_public_path__ + "img/ep-W-dosis.6fbcecbf.jpg";